import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { QuantifyActionType } from '@modules/quantify/store/quantifyActionType';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { QueryBuilderStoreProvider } from '@modules/queryBuilder/store/QueryBuilderStoreProvider';
import { Stack } from '@mui/material';
import { useUnmount } from 'react-use';
import { QuantifyAnalysisToolbarV2 } from '../QuantifyAnalysisToolbarV2';
import { QuantifyQueryBuilder } from '../QuantifyQueryBuilder';
import { QuantifyReport } from '../QuantifyReport';

export function QuantifyAnalysis() {
  const resetToEmptyAnalysis = useAnalysisStore(
    ({ resetToEmptyAnalysis }) => resetToEmptyAnalysis,
  );
  const viewToken = useAnalysisStore(({ viewToken }) => viewToken);
  const dispatch = useQuantifyStore(({ dispatch }) => dispatch);

  useUnmount(() => {
    if (viewToken) {
      resetToEmptyAnalysis();
      dispatch({
        type: QuantifyActionType.RESET_QUERY,
      });
    }
  });

  return (
    <QueryBuilderStoreProvider>
      <Stack alignItems="center">
        <Stack spacing={2} sx={{ p: 2, width: '100%', maxWidth: 1600 }}>
          <QuantifyAnalysisToolbarV2 />
          <Stack direction="row" alignItems="start" spacing={4}>
            <QuantifyQueryBuilder />
            <QuantifyReport />
          </Stack>
        </Stack>
      </Stack>
    </QueryBuilderStoreProvider>
  );
}
